var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUserManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 8C14.2013 8 12.9703 9.4518 13.2657 11.2266L13.7149 13.9154C13.8921 14.9818 14.9193 15.8516 16.0001 15.8516C17.0809 15.8516 18.1081 14.9818 18.2853 13.9154L18.7345 11.2266C19.0293 9.4518 17.7989 8 16.0001 8ZM17.4195 11.0084L16.9703 13.6958C16.8999 14.119 16.4285 14.518 16.0001 14.518C15.5717 14.518 15.1003 14.119 15.0299 13.6966L14.5807 11.007C14.5033 10.5428 14.6041 10.117 14.8647 9.8098C15.1251 9.5026 15.5279 9.3332 16.0001 9.3332C16.4723 9.3332 16.8751 9.5026 17.1349 9.8098C17.3959 10.1172 17.4967 10.543 17.4195 11.0084Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.612 17.0934L18.5684 16.077C17.8932 16.7522 16.976 17.1852 16 17.1852C15.0248 17.1852 14.1068 16.7522 13.4322 16.077L10.388 17.0934C9.80857 17.286 9.33337 17.9436 9.33337 18.5556V24.0002H22.6666V18.5554C22.6666 17.9436 22.192 17.286 21.612 17.0934ZM10.6666 22.6668V18.5554C10.6758 18.502 10.7612 18.3836 10.819 18.3542L13.1472 17.5776C13.7164 17.9844 14.359 18.2572 15.0222 18.3998L15.3336 19.3334L14.6668 22.6666H10.6666V22.6668ZM21.3334 22.6668H17.3334L16.6666 19.3336L16.978 18.4C17.6412 18.2574 18.2838 17.9846 18.853 17.5778L21.1896 18.3582C21.239 18.3836 21.325 18.5022 21.3342 18.5666L21.3334 22.6668Z",
    fill: "#1890FF"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-management.3287f6dd.svg";
export { ForwardRef as ReactComponent };